var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("table", { staticClass: "list-anonymisations" }, [
    _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [
          _c("div", [
            _vm._m(0),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.$t("label.access")))]),
          ]),
        ]),
        _vm._v(" "),
        _c("th", [
          _c("div", [
            _vm._m(1),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.$t("label.staffs")))]),
          ]),
        ]),
        _vm._v(" "),
        _c("th", [
          _c("div", [
            _vm._m(2),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.$t("label.residents")))]),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("tbody", [
      _c("tr", [
        _c("th", [_vm._v(_vm._s(_vm.$t("label.number_anonymised")))]),
        _vm._v(" "),
        _c("td", [
          _vm._v(
            _vm._s(_vm.getAnonymisationsNumber(_vm.anonymisationData?.access))
          ),
        ]),
        _vm._v(" "),
        _c("td", [
          _vm._v(
            _vm._s(_vm.getAnonymisationsNumber(_vm.anonymisationData?.staffs))
          ),
        ]),
        _vm._v(" "),
        _c("td", [
          _vm._v(
            _vm._s(
              _vm.getAnonymisationsNumber(_vm.anonymisationData?.residents)
            )
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("th", [_vm._v(_vm._s(_vm.$t("label.last_anonymisation_date")))]),
        _vm._v(" "),
        _c("td", [
          _vm._v(
            _vm._s(_vm.getLastAnonymisationDate(_vm.anonymisationData?.access))
          ),
        ]),
        _vm._v(" "),
        _c("td", [
          _vm._v(
            _vm._s(_vm.getLastAnonymisationDate(_vm.anonymisationData?.staffs))
          ),
        ]),
        _vm._v(" "),
        _c("td", [
          _vm._v(
            _vm._s(
              _vm.getLastAnonymisationDate(_vm.anonymisationData?.residents)
            )
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [_c("i", { staticClass: "fa-solid fa-shield-halved" })])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [_c("i", { staticClass: "fa-solid fa-user-doctor" })])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [_c("i", { staticClass: "fa-solid fa-person-cane" })])
  },
]
render._withStripped = true

export { render, staticRenderFns }